const PENDING_REDIRECT_DESTINATION_KEY = 'pendingRedirectDestination';

export const setPendingRedirectDestination = (destination: string | null) => {
    if (typeof window === 'undefined') {
        return;
    }
    if (destination === null) {
        sessionStorage.removeItem(PENDING_REDIRECT_DESTINATION_KEY);
    } else {
        sessionStorage.setItem(PENDING_REDIRECT_DESTINATION_KEY, destination);
    }
};

export const getPendingRedirectDestination = (): string | null => {
    if (typeof window === 'undefined') {
        return null;
    }
    return sessionStorage.getItem(PENDING_REDIRECT_DESTINATION_KEY);
};
